import { PropsWithChildren, useMemo } from 'react';

import { PreparedWorkload } from 'features/workload-optimization';

import { apiToFormModelV2, formModelToApiV2 } from './_utils';
import { validateRightsizingSettingsV2 } from './_validations/rightsizing-settings-v2-validation.schema';
import { RightsizingSettingsFormBase } from './RightsizingSettingsFormBase';
import { useHpaV2Status } from '../../_hooks/useHpaV2Status';

/**
 * Form component for workload rightsizing settings (V2 - advanced HPA).
 * Use when showHpaV2 feature flag is true.
 * Supports vertical scaling and advanced horizontal scaling (metrics, behavior, custom HPA settings).
 */
export const RightsizingSettingsFormV2 = ({
  workload,
  children,
}: PropsWithChildren<{
  workload: PreparedWorkload;
}>) => {
  const { hpaV2Status } = useHpaV2Status();

  const initialValue = useMemo(
    () => apiToFormModelV2(workload, hpaV2Status),
    [hpaV2Status, workload]
  );

  return (
    <RightsizingSettingsFormBase
      workload={workload}
      initialValue={initialValue}
      validate={validateRightsizingSettingsV2}
      formModelToApiFn={formModelToApiV2}
    >
      {children}
    </RightsizingSettingsFormBase>
  );
};
